import styled from '@emotion/styled';
import { FONT, SPACING, COLORS3 } from '../../styles/emotion';

export const CategoryList = styled.ul`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  row-gap: ${SPACING.S16};
  padding: 0;
  margin: 0;

  li {
    list-style: none;
  }

  li a {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${SPACING.XS};
  }
`;

export const VendorName = styled.p`
  text-transform: none;
  color: ${COLORS3.BLACK_100};
  margin: 0;
  font-size: ${FONT.FONT_SIZE_SMALLER};
  text-align: center;
`;
